import React from 'react'
import { useNavigate } from "react-router-dom";
import Logo from "../assets/boj-images/white_boj_icon.png";
import banner from "../assets/boj-images/boj_banner.jpg"

const CommonHeader = ({redirection}) => {
  const navigate = useNavigate();

  return (
    <>
      <div>
        <div className="">
            {/* <a>
              <img
                src={Logo}
                alt="logo-img"
                className="my-1 mx-5"
                style={{ height: "60px", width: "60px",cursor:'pointer' }}
              
                onClick={() => navigate(redirection)}

            
              />
            </a> */}
            {/* <div className="d-flex mx-auto align-items-center">
            <span className="fw-bold fs-1" style={{ textAlign: "center" }}>
              {currentYear}
            </span>
          </div> */}
          </div>
      </div>
    </>
  )
}

export default CommonHeader
